import { DropboxFileItem } from '@common/types/dropbox';
import { createContext, Dispatch, SetStateAction, useContext } from 'react';

export const MediaAssetsContext = createContext<
    | {
          selectedMediaAsset: DropboxFileItem | null;
          setSelectedMediaAsset: Dispatch<SetStateAction<DropboxFileItem | null>>;
          visibleMediaAssets: DropboxFileItem[];
          setVisibleMediaAssets: Dispatch<SetStateAction<DropboxFileItem[]>>;
          galleryOpen: boolean;
          setGalleryOpen: Dispatch<SetStateAction<boolean>>;
      }
    | undefined
>(undefined);

export const useMediaAssetsContext = () => {
    const context = useContext(MediaAssetsContext);
    if (context === undefined) {
        throw new Error('useMediaAssetsContext must be used within a MediaAssetsProvider');
    }
    return context;
};
